import { motion } from "framer-motion";
import topImage from './top.png';
import bottomImage from './bottom.png';
import './about.scss';

export default function About() {
    return (
        <div id="about" className="about">
            <div className="about__wrapper container">

                <motion.div
                    className="about__main"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <motion.div
                        className="about__text-wrapper"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        <h4 className="about__subtitle">
                            Every part of our platform is optimized for performance:
                        </h4>
                        <ul className="about__list">
                            <li>ultra-low latency order execution</li>
                            <li>precision trading signals & smart alerts</li>
                            <li>adaptive charts with intelligent indicators</li>
                        </ul>
                    </motion.div>

                    <motion.div
                        className="about__text-wrapper"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                    >
                        <h4 className="about__subtitle">
                            You get tools trusted by professional traders:
                        </h4>
                        <ul className="about__list">
                            <li>full-feature terminal with advanced settings</li>
                            <li>custom strategy integration</li>
                            <li>API support & trading bots</li>
                        </ul>
                    </motion.div>

                    <motion.a
                        href="#"
                        className="about__button"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        Trade now!
                    </motion.a>
                </motion.div>

                <motion.div
                    className="about__side"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="about__small about__small--top">
                        <img src={topImage} alt="" />
                    </div>
                    <div className="about__small about__small--bottom">
                        <img src={bottomImage} alt="" />
                    </div>
                </motion.div>

                <motion.div
                    className="about__small about__small--mobile about__small--bottom"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                >
                    <img src={bottomImage} alt="" />
                </motion.div>

            </div>
        </div>
    );
}
